app.constant('$ionicLoadingConfig',{
    template: '<ion-spinner></ion-spinner>'
});